import { Button } from '@material-ui/core';
import styled from 'styled-components';
import colors from '../../../styles/settings/colors';

export const InfoContainer = styled.div`
  border: solid 1px #000;
  border-radius: 15px;
  margin-top: 10px;
`

export const RefuseContainer = styled.div`
  margin: 8px 0;

  textarea {
    font-family: 'Segoe UI';
  }

  .MuiTextField-root {
    width: 100%;
  }

  .MuiInputBase-root {
    width: 100%;
  }
  .select-paper {
    border: 2px solid ${colors.sanMarino};
    box-sizing: border-box;
    padding: 0 8px;
  }

  .MuiFormHelperText-root {
    font-family: 'Segoe UI';
  }

  button {
    &.Mui-disabled {
      background-color: rgb(35 45 100 / 90%) !important;
      cursor: not-allowed !important;
    }
  }
`;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  min-width: 200px !important;
`;

export const ErrorMessage = styled.span`
  color: ${colors.tundora};
`;
